import React, { useEffect, useRef } from 'react';
import { PayPalButton } from "react-paypal-button-v2";
import { useCredentials } from '../hooks/useCredentials';

export function PayPalBtn(props) {
  const { type = "subscription", amount, currency, createSubscription, createOrder, onApprove, catchError, onError, onCancel, onSuccess } = props;
  const { step, error, clientSecret = {}, initSetup } = useCredentials();
  const didInit = useRef(false);
  useEffect(() => {
    if (didInit.current) return;
    didInit.current = true;
    initSetup();
  }, [initSetup]);

  const paypalKey = clientSecret['PAYPAL_CLIENT_ID']; // "<PayPal Client ID>"

  return (
    <>
      {
        (step === 'ready' && paypalKey) ? (
          <>
            {
              (type === "subscription") ? (
                <>
                  <PayPalButton
                    amount={amount}
                    currency={currency}
                    createSubscription={(data, details) => createSubscription(data, details)}
                    onApprove={(data, details) => onApprove(data, details)}
                    onError={(err) => onError(err)}
                    catchError={(err) => catchError(err)}
                    onCancel={(err) => onCancel(err)}
                    options={{
                      clientId: paypalKey,
                      vault: true
                    }}
                    style={{
                      // shape: 'rect',
                      // color: 'blue',
                      // layout: 'horizontal',
                      // label: 'subscribe',

                      shape: 'rect',
                      color: 'white',
                      layout: 'vertical',
                      label: 'subscribe'
                    }}
                  />
                </>
              ) : (type === 'pay_now') ? (
                <>
                  <PayPalButton
                    createOrder={(data, actions) => createOrder(data, actions)}
                    onApprove={(data, actions) => onApprove(data, actions)}
                    options={{
                      clientId: paypalKey,
                    }}
                    style={{
                      // shape: 'rect',
                      // color: 'blue',
                      // layout: 'horizontal',
                      // label: 'subscribe',

                      shape: 'rect',
                      color: 'white',
                      layout: 'vertical',
                      label: 'pay' //pay
                    }}
                  />
                </>
              ) : (
                <>
                  <PayPalButton
                    amount={amount}
                    currency={currency}
                    // shippingPreference="NO_SHIPPING" // default is "GET_FROM_FILE"
                    onSuccess={(details, data) => {
                      onSuccess(details, data)
                    }}
                    options={{
                      clientId: paypalKey,
                    }}
                    style={{
                      // shape: 'rect',
                      // color: 'blue',
                      // layout: 'horizontal',
                      // label: 'subscribe',

                      shape: 'rect',
                      color: 'white',
                      layout: 'vertical',
                      label: 'pay' //pay
                    }}
                  />
                </>
              )
            }
          </>
        ) : (
          <>
            <span>Loading...</span>
          </>
        )
      }
    </>
  )
}

export default PayPalBtn;